export default function (transactionAmount: number, fee_type: number, feeSize: number): number {
  return fee_type === 0 ? feeSize : transactionAmount * (feeSize / 100)
}
